import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Garancija from "../pages/garancija/page";
import Povracaj from "../pages/povracaj/page";
import Blog from "../pages/blog/page";
import ZastitaParkingMesta from "../pages/blog/posts/zastita-parking-mesta/page";

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/blog',
    element: <Blog />,
  },
  {
    path: '/blog/posts/zastita-parking-mesta',
    element: <ZastitaParkingMesta />,
  },
  {
    path: '/garancija',
    element: <Garancija />,
  },
  {
    path: '/povracaj',
    element: <Povracaj />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;